module.exports = __webpack_public_path__ + "static/media/7-IMG_6710.b7060974.JPG";